export default {
  header: 'Ofeninformationen',
  text: 'Text',
  bgColor: 'Hintergrundfarbe',
};
